module.exports = __webpack_public_path__ + "img/import_white.2fd16a14.svg";